import {MarginQuizQuestionController} from "./MarginQuizQuestionController";
import {BULL_CALL, PREMIUM} from "../MarginQuizQuestions";

export const Premium = "tfPremiumQuestion";

export function premium() {
    return {
        templateUrl: "app/quiz/margin/questions/Premium.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: PremiumController
    };
}

export class PremiumController extends MarginQuizQuestionController {
    public config = PREMIUM;
}
